import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpService } from '../../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ModalCancelarGrupoService {

  constructor(
    private httpService: HttpService
  ) { }

  saveMenusGrupo(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/roleAccess', data, successHandle, errorHandle);
  }

}

